let $slider = document.querySelector('.js-card-slider')

if ($slider) init($slider)

function init ($slider) {
  import(/* webpackChunkName: 'flickity' */ 'flickity').then(Flickity => {
    let flkty = new Flickity($slider, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: false
    })

    let $progress = document.querySelector('.js-progress')
    let rect = getRect()
    updateProgress()

    window.addEventListener('resize', () => {
      rect = getRect()
      updateProgress()
    })

    function updateProgress () {
      let width = (flkty.size.width + rect.left * 2) / flkty.slideableWidth
      let x = `${((-flkty.x - rect.left) / flkty.slideableWidth) * 100}%`

      $progress.style.transform = `translateX(${x}) scaleX(${width})`
    }

    flkty.on('scroll', updateProgress)
  })
}

function getRect () {
  return $slider.getBoundingClientRect()
}



// WEBPACK FOOTER //
// ./src/js/_card-slider.js